module.exports = __webpack_public_path__ + "static/media/bohaterowie_informatyka.9d44ebf8.svg";